/**
 * QrCode — obecná QR komponenta (SVG) pro linky, párování, platby.
 *
 * Bílý podklad s quiet zónou je záměr: QR musí přečíst každá čtečka
 * i na tmavém motivu. Obsah QR je věc volajícího — sem patří jen render.
 */
import { QRCodeSVG } from 'qrcode.react';
import { cn } from '../../lib/utils';

export function QrCode(props: {
  value: string;
  /** Velikost v px (default 192). */
  size?: number;
  /** Popisek pro čtečky obrazovky. */
  label?: string;
  className?: string;
}) {
  return (
    <div
      className={cn('inline-block rounded-xl bg-white p-3', props.className)}
      role='img'
      aria-label={props.label ?? 'QR kód'}
    >
      <QRCodeSVG
        value={props.value}
        size={props.size ?? 192}
        marginSize={0}
        bgColor='#ffffff'
        fgColor='#000000'
        level='M'
      />
    </div>
  );
}
